/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S13_P1_PostInputs */

const tr_iade_iptal_s13_p1_post = /** @type {(inputs: Iade_Iptal_S13_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'nin 20. maddesindeki yetki hükümleri uygulanır.`)
};

const en_iade_iptal_s13_p1_post = /** @type {(inputs: Iade_Iptal_S13_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` apply.`)
};

const de_iade_iptal_s13_p1_post = /** @type {(inputs: Iade_Iptal_S13_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const ru_iade_iptal_s13_p1_post = /** @type {(inputs: Iade_Iptal_S13_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

/**
* | output |
* | --- |
* | "apply." |
*
* @param {Iade_Iptal_S13_P1_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s13_p1_post = /** @type {((inputs?: Iade_Iptal_S13_P1_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S13_P1_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s13_p1_post(inputs)
	if (locale === "de") return de_iade_iptal_s13_p1_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s13_p1_post(inputs)
	return tr_iade_iptal_s13_p1_post(inputs)
});